import AuthService from "../Services/auth.service";
import NeedAuthService from "../Services/needAuth.service";
import NotNeedAuthService from "../Services/notNeedAuth.service";
import jwt_decode from 'jwt-decode';
import {
  API_ACCOUNT_FAIL,
  API_ACCOUNT_SUCCESS,
  API_PROCESS_TRANSACTION_FAIL,
  API_PROCESS_TRANSACTION_SUCCESS,
  CHANGE_PASSWORD_FAIL,
  CHANGE_PASSWORD_SUCCESS,
  FORGET_PASSWORD_FAIL,
  FORGET_PASSWORD_SUCCESS,
  GENERATE_TOKEN_FAIL,
  GENERATE_TOKEN_SUCCESS,
  LOGIN_FAIL,
  LOGIN_SUCCESS,
  LOGOUT,
  REGISTER_FAIL,
  REGISTER_SUCCESS,
  RESET_PASSWORD_FAIL,
  RESET_PASSWORD_SUCCESS,
  SET_MESSAGE,
  SET_RESPONSE,
  UPDATE_USER_FAIL,
  UPDATE_USER_SUCCESS,
  VALIDATE_CONCURRENT_LOGIN_SUCCESS,
  VALIDATE_CONCURRENT_LOGIN_FAIL,
  ADD_CONTACT_SUCCESS,
  ADD_CONTACT_FAIL,
} from "./types";

import Cookies from 'js-cookie';

//Authorization
export const register =
  (
    name,
    email,
    username,
    mobile,
    password,
    confirmPassword,
    partnerName,
    partnerEmail,
    registration,
    partnerMobile
  ) =>
  (dispatch) => {
    return AuthService.register(
      name,
      email,
      username,
      mobile,
      password,
      confirmPassword,
      partnerName,
      partnerEmail,
      registration,
      partnerMobile
    ).then(
      (response) => {
        dispatch({
          type: REGISTER_SUCCESS,
        });

        dispatch({
          type: SET_MESSAGE,
          payload: [response.Succeeded, response.Message, response.Errors],
        });
        return Promise.resolve();
      },
      (error) => {
        dispatch({
          type: REGISTER_FAIL,
        });

        dispatch({
          type: SET_MESSAGE,
          payload: [
            error.response.data.Succeeded,
            error.response.data.Message,
            error.response.data.Errors,
          ],
        });

        return Promise.reject();
      }
    );
  };

export const resetErrorMessage = () => (dispatch) => {
  dispatch({
    type: SET_MESSAGE,
    payload: null,
  });
}

export const login = (email, password, code) => (dispatch) => {
  return AuthService.login(email, password, code).then(
    (data) => {
      dispatch({
        type: LOGIN_SUCCESS,
        payload: { 
          email: email,
          token: data.Data.JWToken,
          mobile: data.Data.Mobile
        },
      });
      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.Message) ||
        error.message ||
        error.toString();
      dispatch({
        type: LOGIN_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject();
    }
  );
};

export const logout = () => (dispatch) => {
  AuthService.logout();

  dispatch({
    type: LOGOUT,
  });
};

export const addContact = (email, companyName, clientName, phoneNumber, purpose, apiCategories, registrationNumber, recaptchaToken) => (dispatch) => {
  return AuthService.addContact(
    email,
    companyName,
    clientName,
    phoneNumber,
    purpose,
    apiCategories,
    registrationNumber,
    recaptchaToken
  ).then(
    (response) => {
      dispatch({
        type: ADD_CONTACT_SUCCESS,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: [
          response.data.Succeeded,
          response.data.Message,
          response.data.Errors,
        ],
      });
      return Promise.resolve();
    },
    (error) => {
      dispatch({
        type: ADD_CONTACT_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: [
          error.response.data.Succeeded,
          error.response.data.Message,
          error.response.data.Errors,
        ],
      });

      return Promise.reject();
    }
  )
}

export const changePassword =
  (currentPassword, newPassword, confirmPassword) => (dispatch) => {
    return AuthService.changePassword(
      currentPassword,
      newPassword,
      confirmPassword
    ).then(
      (response) => {
        dispatch({
          type: CHANGE_PASSWORD_SUCCESS,
        });

        dispatch({
          type: SET_MESSAGE,
          payload: [
            response.data.Succeeded,
            response.data.Message,
            response.data.Errors,
          ],
        });
        return Promise.resolve();
      },
      (error) => {
        dispatch({
          type: CHANGE_PASSWORD_FAIL,
        });

        dispatch({
          type: SET_MESSAGE,
          payload: [
            error.response.data.Succeeded,
            error.response.data.Message,
            error.response.data.Errors,
          ],
        });

        return Promise.reject();
      }
    );
  };

export const forgetPassword = (email) => (dispatch) => {
  return AuthService.forgetPassword(email).then(
    (response) => {
      dispatch({
        type: FORGET_PASSWORD_SUCCESS,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: [true],
      });
      return Promise.resolve();
    },
    (error) => {
      // const message =
      //   (error.response &&
      //     error.response.data &&
      //     error.response.data.message) ||
      //   error.message ||
      //   error.toString();

      dispatch({
        type: FORGET_PASSWORD_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: [false],
      });

      return Promise.reject();
    }
  );
};

export const resetPassword =
  (email, token, password, confirmPassword) => (dispatch) => {
    return AuthService.resetPassword(
      email,
      token,
      password,
      confirmPassword
    ).then(
      (response) => {
        dispatch({
          type: RESET_PASSWORD_SUCCESS,
        });

        dispatch({
          type: SET_MESSAGE,
          payload: [response.data.Succeeded, response.data.Message],
        });
        return Promise.resolve();
      },
      (error) => {
        // const message =
        //   (error.response &&
        //     error.response.data &&
        //     error.response.data.message) ||
        //   error.message ||
        //   error.toString();

        dispatch({
          type: RESET_PASSWORD_FAIL,
        });

        dispatch({
          type: SET_MESSAGE,
          payload: [
            error.response.data.Succeeded,
            error.response.data.Message,
            error.response.data.Errors,
          ],
        });

        return Promise.reject();
      }
    );
  };

export const refreshToken = () => (dispatch) => {
  var token = Cookies.get("JWToken");
  const user = jwt_decode(token).uid;
  return AuthService.refreshToken(user).then(
    (data) => {
      dispatch({
        type: LOGIN_SUCCESS,
        payload: { token: data.Data.JWToken },
      });
      return Promise.resolve();
    },
    (error) => {
      dispatch({
        type: LOGIN_FAIL,
      });
      return Promise.reject();
    }
  );
};

//Profile
export const updateUser = (userId, userName, mobile, email) => (dispatch) => {
  return NeedAuthService.updateUser(userId,userName, mobile, email).then(
    (response) => {
      dispatch({
        type: UPDATE_USER_SUCCESS,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: [
          response.data.Succeeded,
          response.data.Message,
          response.data.Errors,
        ],
      });

      return Promise.resolve();
    },
    (error) => {
      dispatch({
        type: UPDATE_USER_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: [
          error.response.data.Succeeded,
          error.response.data.Message,
          error.response.data.Errors,
        ],
      });

      return Promise.reject();
    }
  );
};

export const addAPIAccount =
  (apiUserId, apiUserName, apiKey, productAccount, agentId, agentType) =>
  (dispatch) => {
    return NeedAuthService.addAPIAccount(
      apiUserId,
      apiUserName,
      apiKey,
      productAccount,
      agentId,
      agentType
    ).then(
      (response) => {
        dispatch({
          type: API_ACCOUNT_SUCCESS,
        });

        dispatch({
          type: SET_MESSAGE,
          payload: [
            response.data.Succeeded,
            response.data.Message,
            response.data.Errors,
          ],
        });

        return Promise.resolve();
      },
      (error) => {
        // const message =
        //   (error.response &&
        //     error.response.data &&
        //     error.response.data.message) ||
        //   error.message ||
        //   error.toString();

        dispatch({
          type: API_ACCOUNT_FAIL,
        });

        dispatch({
          type: SET_MESSAGE,
          payload: [
            error.response.data.Succeeded,
            error.response.data.Message,
            error.response.data.Errors,
          ],
        });

        return Promise.reject();
      }
    );
  };

export const updateAPIAccount =
  (id, apiUserName, apiKey, agentCode, productAccount) => (dispatch) => {
    return NeedAuthService.updateAPIAccount(
      id,
      apiUserName,
      apiKey,
      agentCode,
      productAccount
    ).then(
      (response) => {
        dispatch({
          type: API_ACCOUNT_SUCCESS,
        });

        dispatch({
          type: SET_MESSAGE,
          payload: [
            response.data.Succeeded,
            response.data.Message,
            response.data.Errors,
          ],
        });

        return Promise.resolve();
      },
      (error) => {
        // const message =
        //     (error.response &&
        //     error.response.data &&
        //     error.response.data.message) ||
        //     error.message ||
        //     error.toString();

        dispatch({
          type: API_ACCOUNT_FAIL,
        });

        dispatch({
          type: SET_MESSAGE,
          payload: [
            error.response.data.Succeeded,
            error.response.data.Message,
            error.response.data.Errors,
          ],
        });

        return Promise.reject();
      }
    );
  };

export const deleteAPIAccount = (id) => (dispatch) => {
  return NeedAuthService.deleteAPIAccount(id).then(
    (response) => {
      dispatch({
        type: API_ACCOUNT_SUCCESS,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: [
          response.data.Succeeded,
          response.data.Message,
          response.data.Errors,
        ],
      });

      return Promise.resolve();
    },
    (error) => {
      // const message =
      //     (error.response &&
      //     error.response.data &&
      //     error.response.data.message) ||
      //     error.message ||
      //     error.toString();

      dispatch({
        type: API_ACCOUNT_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: [
          error.response.data.Succeeded,
          error.response.data.Message,
          error.response.data.Errors,
        ],
      });

      return Promise.reject();
    }
  );
};

//APIToken
export const generateToken = (appId, secretKey) => (dispatch) => {
  return NotNeedAuthService.generateToken(appId, secretKey).then(
    (response) => {
      dispatch({
        type: GENERATE_TOKEN_SUCCESS,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: [
          response.data.Status,
          response.data.Error,
          response.data.Content,
        ],
      });
      return Promise.resolve();
    },
    (error) => {
      // const message =
      //   (error.response &&
      //     error.response.data &&
      //     error.response.data.message) ||
      //   error.message ||
      //   error.toString();

      dispatch({
        type: GENERATE_TOKEN_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: [
          error.response.data.Status,
          error.response.data.Error,
          error.response.data.Content,
        ],
      });

      return Promise.reject();
    }
  );
};

//Sandbox
export const APIProcessTransaction =
  (method, body, inbound, request, APIToken) => (dispatch) => {
    return NotNeedAuthService.APIProcessTransaction(
      method,
      body,
      inbound,
      request,
      APIToken
    ).then(
      (response) => {
        dispatch({
          type: API_PROCESS_TRANSACTION_SUCCESS,
        });

        dispatch({
          type: SET_RESPONSE,
          payload: response,
        });
        return Promise.resolve();
      },
      (error) => {
        // const message =
        //   (error.response &&
        //     error.response.data &&
        //     error.response.data.message) ||
        //   error.message ||
        //   error.toString();

        dispatch({
          type: API_PROCESS_TRANSACTION_FAIL,
        });

        dispatch({
          type: SET_RESPONSE,
          payload: error.response.data,
        });

        return Promise.reject();
      }
    );
  };

export const validateConcurrentLogin = (id, concurrencyLoginStamp) => (dispatch) => {
  return AuthService.validateConcurrentLogin(id, concurrencyLoginStamp).then(
    (data) => {
      if(data.Data === false){
        dispatch({
          type: VALIDATE_CONCURRENT_LOGIN_SUCCESS,
          payload: { isUniqueLogin: data.Data },
        });
        return Promise.reject();
      }
      return Promise.resolve();
    },
    (error) => {
      dispatch({
        type: VALIDATE_CONCURRENT_LOGIN_FAIL,
        payload: { isUniqueLogin: false },
      });
      return Promise.reject();
    }
  );
};